import React from 'react';

import css from './TermsTemplate.module.css';

interface IProps {
  seoTitle?: string;
  contentBlocks: { raw?: string; value: string; type: string }[];
  slug: string;
}

const TermsTemplate: React.FC<React.PropsWithChildren<IProps>> = ({
  seoTitle = '',
  contentBlocks,
  children,
}) => {
  return (
    <>
      <div className="grid justify-items-stretch xs:px-4 sm:px-8">
        <div className="max-w-md mb-16 justify-self-center">
          <h1 className="my-16 h3">{seoTitle}</h1>
          {contentBlocks?.map((content, i) => {
            return (
              <div
                className={`${css.content}`}
                key={i}
                dangerouslySetInnerHTML={{ __html: content.value }}
              />
            );
          })}
        </div>
        <div />
      </div>
      <>{children}</>
    </>
  );
};

export default TermsTemplate;
